export const uri = {
  // address: {
  //   getProvince: '/address/selectByProvince',
  //   getCity: '/address/selectByCity',
  //   getDistrict: '/address/selectBySelective',
  // },
  platformConfig: '/sysConfig/selectBySelective',
  sysDict: {
    selectByTypeCode: '/sysDict/selectByTypeCode'
  },
  registry: "/customerValidater/registry",
  thirdPartyBinding: "/customerAuth/thirdPartyBinding",
  phoneMessage: {
    sendSmSLogin: "/customerValidater/sendSmSLogin",//发送登录的验证码
    checkPhoneExist: "/customerValidater/checkPhoneExist",//验证要注册手机号是否存在
    getPhoneValidate: "/customerValidater/phoneValidate",//获取注册--普通验证码
    sendSMSByUserId: "/customerValidater/sendSMSByUserId"//找回密码的获取信息
  },
  login: {
    login: "/login",
    loginMobile: "/loginMobile",
    logout: "/logout",
    thirdLogin: "/thirdPartyAuth"
  },

  account: {
    customer: {
      updatePassword: "/customerValidater/updatePassword",//修改密码
      amendValidateSmsCode: "/customerValidater/amendValidateSmsCode"
    }
  },
  notice: {
    add: '/fzNotice/save',
    getPageList: '/fzNotice/getFzNoticeByPage',
    delete: '/fzNotice/softDeleteByIds',
    update: '/fzNotice/updateBySelective',
  },
  version: {
    add: '/sysVersion/save',
    getPageList: '/sysVersion/getSysVersionByPage',
    get:'/sysVersion/selectBySelective',
    delete: '/sysVersion/softDeleteByIds',
    update: '/sysVersion/updateBySelective',
    getDetail: '/sysVersion/getSysVersionById/',
    getAll: '/sysVersion/selectBySelective'
  },
  setting: {
    checkCard: '/welfareCard/isSystem/',

  },
  systemNotice:{
    getNoticeList:'/fzNotice/getFzNoticeByPage'
  }


};
export const testUri = {
  // testGoodsList: '/test/getGoodsRandom',
  // testServiceList: '/test/getServiceRandom',
};
//七牛公共空间的key
export const qiniuPublicUri = "/qiniu/getPublicUploadKey";
export const qiniuPublicGetFile = "/qiniu/getPublicFileUrl";


export const qiniuPrivateUri = "/qiniu/getUploadKey";
// export const qiniuPrivateGetFile = '/qiniu/getPublicFileUrl';


export const qiniuPublicDeleteUri = "/qiniu/deletePublicFileByKeys";
export const qiniuPrivateDeleteUri = "/qiniu/deleteFileByKeys";
//七牛刷新
export const qiniuRefreshUri = "/qiniu/refresh";









// WEBPACK FOOTER //
// ./src/api/uri/base.js